// extracted by mini-css-extract-plugin
module.exports = {"header":"index_header__BU4pj","logo":"index_logo__2tEwb","menus":"index_menus__2FFuO","active":"index_active__2nXPk","footer":"index_footer__Vbav8","main":"index_main__gP3_T"};